if ( typeof WinehouseProducts !== 'function' ) {

  class WinehouseProducts extends HTMLElement {
    constructor() {
      super();
      this.storefront_api_url = `https://${window.Shopify.shop}/api/2025-10/graphql.json`;
      this.allProducts = [];
    }

    async connectedCallback() {
        if (this.dataset.path) {
            this.allProducts = await this.metaobjectId(this.dataset.handle, this.dataset.id);
            await this.renderProducts();
        }
    }

    async metaobjectId(metaobjectId, id) {
        
        try {
            let cursor = null;
            let first = 50;
            let allProducts = [];
            let hasNextPage = true;  

            while (hasNextPage) {
                const query = `
                query ProductsByMetaobject($queryString: String!, $cursor: String) {
                    products(
                    first: 10
                    after: $cursor
                    query: $queryString
                    ) {
                    edges {
                        cursor
                        node {
                        id
                        title
                        handle
                        }
                    }
                    pageInfo {
                        hasNextPage
                    }
                    }
                }
                `;

                const filterByMetaObject =`
                query WinehouseProducts( $handle: String! $winehouseGid: String! $first: Int! $cursor: String ) {
                    collection(handle: $handle) { 
                        id 
                        title 
                        products( 
                            first: $first 
                            after: $cursor 
                            filters: [ { productMetafield: { namespace: "wijnkenmerken" key: "winehouse" value: $winehouseGid } } ] ) { 
                            edges { 
                                cursor 
                                node { 
                                    id 
                                    title 
                                    handle 
                                } 
                            } 
                            pageInfo { 
                                hasNextPage 
                            } 
                        } 
                    } 
                }
                `

                const response = await fetch(this.storefront_api_url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": this.dataset.path
                    },
                    body: JSON.stringify({
                        query,
                        variables: { queryString: `metafield:wijnkenmerken.winehouse.metaobject_ref:${metaobjectId}` , cursor }
                    })
                });
            
                // const json = await response.json();
                // const data = json.data.products;

                const responseMetaobject = await fetch(this.storefront_api_url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": this.dataset.path
                    },
                    body: JSON.stringify({
                        query: filterByMetaObject,
                        variables: { handle: 'all' , winehouseGid: `gid://shopify/Metaobject/${id}` , first, cursor }
                    })
                });

                const jsonMetaObject = await responseMetaobject.json();
                const dataMetaObject = jsonMetaObject.data.collection.products;
                
                // Add products to array
                // allProducts.push(...data.edges.map(edge => edge.node));
                allProducts.push(...dataMetaObject.edges.map(edge => edge.node));

                
                // Update pagination cursor
                // hasNextPage = data.pageInfo.hasNextPage;
                hasNextPage = dataMetaObject.pageInfo.hasNextPage;
                if (allProducts.length >= parseInt(this.dataset.maxItems, 10)) {
                    hasNextPage = false;
                    allProducts = allProducts.slice(0, parseInt(this.dataset.maxItems, 10));
                }
                // cursor = hasNextPage ? data.edges[data.edges.length - 1].cursor : null;
                cursor = hasNextPage ? dataMetaObject.edges[dataMetaObject.edges.length - 1].cursor : null;
            }

            return allProducts;

        } catch(error) {
            console.log(error.message);
        }
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html')?.querySelector(selector)?.innerHTML;
    }

    async renderProducts() {
        // get only the productIds for query params.
        const ids = this.allProducts.map((product) => product?.handle)?.join(',');
        const url = `/?section_id=wine-house-products&ids=${ids}&settings=`;
        const html = await fetch(url).then(response => response.text());
        if (this.querySelector(`#${this.dataset.sectionId}`)) {
            const innerHTML = this.getSectionInnerHTML(html, `#shopify-section-wine-house-products`);
            this.querySelector(`#${this.dataset.sectionId}`).innerHTML = innerHTML;
        }
    }
  }


  if ( typeof customElements.get('wine-house') == 'undefined' ) {
    customElements.define('wine-house', WinehouseProducts);
  }
}